import { Grid, makeStyles } from "@material-ui/core";
import { Create } from "react-admin";
import CustomForm from "./CustomForm";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    marginTop: 0,
    paddingTop: 30,
    boxSizing: "border-box",
  },
  main: {
    height: "100%",
    marginTop: 0,
  },
  card: {
    borderRadius: 0
  }
}));

const LeftGridCreate = (props) => {
  const { children, validate } = props;
  const classes = useStyles();
  return (
    <Grid item xs={8} style={{ height: "100%" }}>
      <Create
        classes={{ root: classes.root, main: classes.main, card: classes.card }}
        {...props}
      >
        <CustomForm noDelete={true} validate={validate}>
          {children}
        </CustomForm>
      </Create>
    </Grid>
  );
};

export default LeftGridCreate;
